import { withStyles } from "@material-ui/core"
import Typography from "@mui/material/Typography"
import React, { useEffect, useState } from "react"
import { grayColor } from "../../../style/style"
import WidgetCommon from "../Common/widgetCommon"

const styles = () => ({})

const TotalInsights = (props) => {
  const {
    isLoading,
    devices,
    allowEdits,
    handleWidgetChange,
    widgetId,
    gridStep,
    position,
    size,
    handleRemove,
  } = props
  const [totalDevices, setTotalDevices] = useState(null)

  useEffect(() => {
    if (devices) {
      setTotalDevices(devices.length)
    }
  }, [devices])

  return (
    <WidgetCommon
      widgetId={widgetId}
      title="Total Devices"
      isLoading={isLoading}
      hasNoData={!totalDevices}
      size={size}
      position={position}
      allowResize={true}
      allowEdits={allowEdits}
      handleWidgetChange={handleWidgetChange}
      gridStep={gridStep}
      handleRemove={handleRemove}
    >
      <br></br>
      <Typography variant="h2" style={{ color: grayColor[2] }}>
        {totalDevices}
      </Typography>
    </WidgetCommon>
  )
}

export default withStyles(styles)(TotalInsights)
